import { createEnvironment } from "@product/scmp-sdk";
import { hydrateRelayEnvironment } from "relay-nextjs";
import type { Environment } from "relay-runtime";

import { getAccountState, SCMPAccessTokenCookiesKey } from "~/lib/account";

import { createNetworkOptions } from "./network-options";

let clientEnvironmentWithoutCred: Environment;

export function createClientEnvironment() {
  if (typeof window === "undefined") return clientEnvironmentWithoutCred;
  const { accessToken } = getAccountState();
  if (clientEnvironmentWithoutCred === undefined) {
    clientEnvironmentWithoutCred = createEnvironment(
      createNetworkOptions({
        cookies: { [SCMPAccessTokenCookiesKey]: accessToken },
        credentials: "omit",
      }),
      {},
      {},
    );
    hydrateRelayEnvironment(clientEnvironmentWithoutCred);
  }

  return clientEnvironmentWithoutCred;
}

let clientEnvironmentWithCred: Environment;

export function createClientEnvironmentWithCred() {
  if (typeof window === "undefined") return clientEnvironmentWithCred;
  const { accessToken } = getAccountState();
  if (clientEnvironmentWithCred === undefined) {
    clientEnvironmentWithCred = createEnvironment(
      createNetworkOptions({
        cookies: { [SCMPAccessTokenCookiesKey]: accessToken },
        credentials: "include",
      }),
      {},
      {},
    );
    hydrateRelayEnvironment(clientEnvironmentWithCred);
  }

  return clientEnvironmentWithCred;
}
